/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./LoginPage.module.css";

interface InputFieldProps {
  label: string;
  type: string;
  id: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  type,
  id,
  value,
  onChange,
}) => {
  return (
    <div className={styles.inputWrapper}>
      <div className={styles.inputField}>
        <label htmlFor={id} className={styles["visually-hidden"]}>
          {label}
        </label>
        <input
          type={type}
          id={id}
          placeholder={label}
          aria-label={label}
          className={styles.input}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default InputField;
